function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRanta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M24.7941 13.6396C24.5857 13.4312 24.2489 13.4312 24.0404 13.6396L13.1946 24.4855C12.9861 24.694 12.9861 25.0307 13.1946 25.2392C13.3015 25.3461 13.4351 25.3942 13.5741 25.3942C13.713 25.3942 13.8467 25.3408 13.9536 25.2392L24.7994 14.3933C25.0079 14.1849 25.0079 13.8481 24.7994 13.6396H24.7941Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5316 13.3026C12.5748 14.2594 12.5748 15.8149 13.5316 16.7718C14.0073 17.2476 14.6381 17.4881 15.2635 17.4881C15.8889 17.4881 16.5196 17.2476 16.9954 16.7718C17.9522 15.815 17.9522 14.2595 16.9954 13.3026C16.0386 12.3457 14.483 12.3458 13.5262 13.3026H13.5316ZM16.2417 16.0127C15.7018 16.5526 14.8251 16.5526 14.2853 16.0127C13.7454 15.4728 13.7454 14.5962 14.2853 14.0563C14.5525 13.789 14.9107 13.65 15.2634 13.65C15.6162 13.65 15.9744 13.7837 16.2416 14.0563C16.7815 14.5962 16.7816 15.4728 16.2417 16.0127Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6675 21.4333C21.2024 21.8983 20.9512 22.513 20.9512 23.1652C20.9512 23.8173 21.2078 24.4374 21.6675 24.8971C22.1432 25.3728 22.7739 25.6133 23.3994 25.6133C24.0248 25.6133 24.6555 25.3728 25.1313 24.8971C26.0881 23.9403 26.0881 22.3847 25.1313 21.4278C24.1745 20.4709 22.6189 20.471 21.662 21.4278L21.6675 21.4333ZM24.3775 22.187C24.9174 22.7269 24.9174 23.6035 24.3775 24.1434C23.8377 24.6833 22.961 24.6833 22.4211 24.1434C22.1592 23.8815 22.0149 23.534 22.0149 23.1652C22.0149 22.7964 22.1592 22.4489 22.4211 22.187C22.6884 21.9197 23.0466 21.7808 23.3993 21.7808C23.7521 21.7808 24.1049 21.9144 24.3775 22.187L24.3775 22.187Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.989 19.4393C31.989 14.9705 29.7386 10.8758 25.9594 8.47598C25.7081 8.31561 25.3821 8.39045 25.2217 8.64168C25.0614 8.89292 25.1362 9.21898 25.3874 9.37934C28.8512 11.5816 30.9198 15.3448 30.9198 19.4446C30.9198 25.5543 26.296 30.6058 20.3682 31.29L20.8118 30.8463C21.0203 30.6379 21.0203 30.3011 20.8118 30.0926C20.6034 29.8841 20.2666 29.8842 20.0581 30.0926L18.6202 31.5306C18.5721 31.5787 18.5293 31.6375 18.5026 31.7069C18.4759 31.7711 18.4598 31.8406 18.4598 31.9101C18.4598 31.9796 18.4759 32.0491 18.5026 32.1132C18.5293 32.1773 18.5667 32.2361 18.6202 32.2896L20.0581 33.7275C20.165 33.8344 20.2987 33.8825 20.4376 33.8825C20.5766 33.8825 20.7102 33.8291 20.8171 33.7275C21.0256 33.519 21.0256 33.1823 20.8171 32.9738L20.2345 32.3911C26.8254 31.7711 31.9997 26.2065 31.9997 19.4553L31.989 19.4393Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6017 29.5045C9.1379 27.3022 7.0693 23.5391 7.0693 19.4392C7.0693 13.3295 11.6931 8.27808 17.6209 7.59388L17.1773 8.03753C16.9688 8.246 16.9688 8.58276 17.1773 8.79124C17.2842 8.89815 17.4178 8.94626 17.5568 8.94626C17.6958 8.94626 17.8294 8.8928 17.9363 8.79124L19.3742 7.35332C19.4223 7.30521 19.4651 7.24641 19.4918 7.17692C19.5186 7.11278 19.5346 7.04329 19.5346 6.9738C19.5346 6.90431 19.5186 6.83482 19.4918 6.77067C19.4651 6.70653 19.4277 6.64773 19.3742 6.59427L17.9363 5.15635C17.7278 4.94788 17.3911 4.94788 17.1826 5.15635C16.9741 5.36482 16.9741 5.70158 17.1826 5.91007L17.7653 6.49273C11.1743 7.11279 6 12.6774 6 19.4286C6 23.8973 8.25042 27.992 12.0296 30.3919C12.1205 30.4507 12.2167 30.4774 12.3182 30.4774C12.4946 30.4774 12.6657 30.3919 12.7673 30.2315C12.9276 29.9803 12.8528 29.6542 12.6015 29.4938L12.6017 29.5045Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanta);
export default __webpack_public_path__ + "static/media/ranta.81565c1ef7ba27815756d5e388aafb1f.svg";
export { ForwardRef as ReactComponent };